import React, {useEffect} from "react";
import { ReactTyped } from "react-typed";

import { Container, Row, Col, Button } from "react-bootstrap";

// import Images
import homeAbout from "../assets/images/home/home-about.jpg";
import video from "../assets/video/home.mp4"

import { Link } from "react-router-dom";
import useLang from "hooks/useLang";

const Home = () => {
  const { lang } = useLang();
  
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  return (
    <React.Fragment>
      <section id="hero">
      <video src={video} playsInline="true" type="video/mp4" autoPlay muted="false" loop id="hero-video">
      </video>
        <div class="hero-container">
          <div data-aos="fade-in" style={{marginBottom: "20px"}}>
            <h1>{lang.home.hero_title}</h1>
            <h2>
              {lang.home.hero_body}{" "}
              <ReactTyped
                strings={lang.home.hero_body_list}
                typeSpeed={40}
                backSpeed={50}
                loop
              />
            </h2>
            <div class="actions">
              <a href="#home" class="btn-get-started">
                {lang.home.cta_1}
              </a>
              <a href="#our-services" class="btn-services">
                {lang.home.cta_2}
              </a>
            </div>
          </div>
        </div>
      </section>
      <section
        className="home-1 bg-home d-flex align-items-center anchor"
        id="home"
        style={{
          height: "auto",
        }}
      >
        <Container>
          <Row className="justify-content-center">
            <section>
              <Container>
                <Row className="align-items-center">
                  <Col lg={6}>
                    <div className="work-pra">
                      <p
                        style={{
                          fontSize: "xx-large",
                          lineHeight: "inherit",
                        }}
                      >
                        {lang.home.section_1_title}
                      </p>
                      <p className="text-muted text-justify">
                        {lang.home.section_1_body}
                      </p>
                      <div className="home-cta-button-group">
                        <Button href="#contact-adinata" className="home-cta-button">{lang.component.contact_us}</Button>
                        <Link to="/about-us">
                          <Button className="home-cta-button">{lang.home.cta_3}</Button>
                        </Link>
                      </div>
                    </div>
                  </Col>
                  <Col lg={6} data-aos="fade-right">
                    <img
                      src={homeAbout}
                      alt=""
                      className="fill-available home-about-img"
                    />
                  </Col>
                </Row>
              </Container>
            </section>
          </Row>
        </Container>
      </section>
    </React.Fragment>
  );
};

export default Home;
